/**
 * Map API error codes to user-facing messages (same as Next errorHandler).
 * @param {{ code?: number, message?: string }} error
 * @returns {string}
 */
export function handleApiError(error) {
  if (!error) return 'An unexpected error occurred';
  const code = error.code;
  const message = error.message;
  switch (code) {
    case 400:
      return message || 'Invalid request. Please check your input.';
    case 401:
      return message || 'Invalid credentials. Please try again.';
    case 403:
      return message || 'Access denied. You do not have permission.';
    case 409:
      return message || 'This resource already exists.';
    case 419:
      return message || 'Your session has expired. Please login again.';
    case 500:
      return message || 'Server error. Please try again later.';
    default:
      return message || 'An unexpected error occurred.';
  }
}
